import React, { useState, useEffect, useRef } from "react";

const HorizontalDatePicker = ({ selectedDate, setSelectedDate }) => {
  const [visibleMonthYear, setVisibleMonthYear] = useState("");
  const containerRef = useRef(null);
  const cardRef = useRef(null);

  const daysBefore = 7;
  const daysAfter = 90;

  const generateDates = (daysBefore, daysAfter) => {
    const dates = [];
    const today = new Date();
    for (let i = -daysBefore; i <= daysAfter; i++) {
      const date = new Date();
      date.setDate(today.getDate() + i);
      dates.push(date);
    }
    return dates;
  };

  const dates = generateDates(daysBefore, daysAfter);

  useEffect(() => {
    if (cardRef.current && containerRef.current) {
      const cardWidth = cardRef.current.offsetWidth + 10;
      const selectedDateStr = selectedDate.toDateString();
      const todayIndex = dates.findIndex(
        (d) => d.toDateString() === selectedDateStr
      );

      if (todayIndex !== -1) {
        containerRef.current.scrollLeft = todayIndex * cardWidth;
      }
    }
  }, []);

  useEffect(() => {
    updateVisibleMonthYear(dates[daysBefore]);
  }, []);

  const updateVisibleMonthYear = (date) => {
    const month = date.toLocaleString("default", { month: "long" });
    const year = date.getFullYear();
    setVisibleMonthYear(`${month} ${year}`);
  };

  const handleScroll = () => {
    if (!containerRef.current || !cardRef.current) return;
    const scrollLeft = containerRef.current.scrollLeft;
    const cardWidth = cardRef.current.offsetWidth + 10;
    const index = Math.round(scrollLeft / cardWidth);
    const date = dates[index] || new Date();
    updateVisibleMonthYear(date);
  };

  return (
    <div>
      <h4
        style={{
          marginLeft: 10,
          marginBottom: 5,
          color: "#E7666A",
          fontSize: "16px",
        }}
      >
        {visibleMonthYear}
      </h4>

      <div
        ref={containerRef}
        onScroll={handleScroll}
        style={{
          display: "flex",
          overflowX: "auto",
          padding: "10px",
          gap: "10px",
          scrollSnapType: "x mandatory",
          scrollbarWidth: "none",
          msOverflowStyle: "none",
        }}
      >
        {dates.map((date, idx) => {
          const isSelected =
            selectedDate.toDateString() === date.toDateString();
          const isToday = idx === daysBefore;

          return (
            <div
              key={idx}
              ref={isToday ? cardRef : null}
              onClick={() => setSelectedDate(date)}
              style={{
                minWidth: 50,
                minHeight: 60,
                padding: "5px 10px",
                textAlign: "center",
                borderRadius: 10,
                scrollSnapAlign: "start",
                cursor: "pointer",
                background: isSelected ? "#E7666A" : "#f2f2f2",
                color: isSelected ? "#fff" : "#000",
                fontWeight: isSelected ? "bold" : "normal",
              }}
            >
              <div>{date.toLocaleString("default", { weekday: "short" })}</div>
              <div>{date.getDate()}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default HorizontalDatePicker;
